import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
    public intercept(req: HttpRequest<any>, next: HttpHandler) {
        return next.handle(
            req.clone({
                headers: req.headers.set("Accept-Language", localStorage.getItem("lang") ?? "fr")
            })
        );
    }
}
